var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 41,
    viewBox: "0 0 32 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.21 15.7599C21.21 18.6299 18.89 20.95 16.02 20.95C13.15 20.95 10.83 18.6299 10.83 15.7599C10.83 12.8899 13.15 10.5699 16.02 10.5699C18.89 10.5699 21.21 12.8899 21.21 15.7599Z",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.02 17.33C16.8871 17.33 17.59 16.627 17.59 15.7599C17.59 14.8929 16.8871 14.1899 16.02 14.1899C15.1529 14.1899 14.45 14.8929 14.45 15.7599C14.45 16.627 15.1529 17.33 16.02 17.33Z",
    fill: "#00C9B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.26 37.7599C15.7 38.1299 16.34 38.1299 16.78 37.7599C19.79 35.2299 30.68 25.41 30.68 16.02C30.68 8.09996 24.12 1.68994 16.02 1.68994C7.91999 1.68994 1.35999 8.10996 1.35999 16.02C1.35999 25.41 12.25 35.2199 15.25 37.7599",
    stroke: "#2E63EE",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.26 37.7599C15.7 38.1299 16.34 38.1299 16.78 37.7599C19.79 35.2299 30.68 25.41 30.68 16.02C30.68 8.09996 24.12 1.68994 16.02 1.68994C7.91999 1.68994 1.35999 8.10996 1.35999 16.02C1.35999 25.41 12.25 35.2199 15.25 37.7599H15.26Z",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13 39.74H23.49",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.93bed2551b7edd0caf4b1209c8758725.svg";
export { ForwardRef as ReactComponent };